<template lang="pug">
  .b2b-page-tax
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(v-if='!this.isNuevo', :span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(v-if='this.isNuevo', :span='8')
            div {{ $t('taxes.new') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("taxes.delete_tax_tooltip")', placement='bottom')
                ods-button(
                  v-if='!this.isNuevo && this.canAdminTaxes'
                  type='primary',
                  icon='ods-icon-delete',
                  size='small',
                  circle,
                  @click.native='handleRemoveTax')
                  | {{ $t('buttons.btnDelete') }}
      ods-form(
        ref='taxDetailEditForm',
        :model='taxDetailEditForm',
        :rules='rulesTaxDetailEditForm',
        label-width='14rem',
        label-position='top',
        size='mini',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("taxes.filters.project.value")',
              prop='project')
              ods-select(
                v-model="taxDetailEditForm.project",
                :placeholder='$t("taxes.filters.project.placeholder")',
                filterable,
                :disabled='!this.isNuevo')
                ods-option(
                  v-for='optionService in modifiedOptionsFilterService',
                  :key='optionService.id',
                  :label='optionService.name',
                  :value='optionService.id')
          ods-col(:span='4')
          ods-col(:span='10')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("taxes.filters.type.value")',
              prop='taxType')
              ods-select(
                v-model="taxDetailEditForm.taxType",
                :placeholder='$t("taxes.filters.type.placeholder")',
                :disabled='!this.isNuevo')
                ods-option(
                  :id='tax.id',
                  v-for='tax in optionsFilterInvoiceTaxType',
                  :key='tax.id',
                  :label="$t('adminTaxes.tax.' + tax.code)",
                  :value='tax.id')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              prop='country',
              :label='$t("projects.validities.country")')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='taxDetailEditForm.country',
                filterable,
                :placeholder='$t("projects.validities.country")'
                :disabled='!this.isNuevo')
                ods-option(
                  v-for='option in countries',
                  :key='option.id',
                  :label='option.name',
                  :value='option.id')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("taxes.filters.rate.value")',
              prop='taxRate')
              ods-input(
                :disabled='!this.isNuevo',
                v-model='taxDetailEditForm.taxRate')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("taxes.validity_date")',
              prop='dateFrom')
              ods-date-picker(
                v-model='taxDetailEditForm.dateFrom',
                type='datetime',
                :format='$t("date_format_calendar")',
                prefix-icon='prefix-icon-date-time-picker',
                :placeholder='$t("msg_generics.datepicker.start_placeholder")')
              ods-date-picker(
                v-model='taxDetailEditForm.dateTo',
                type='datetime',
                :format='$t("date_format_calendar")',
                prefix-icon='prefix-icon-date-time-picker',
                :placeholder='$t("msg_generics.datepicker.end_placeholder")')

    ods-module.collapse
      ods-accordion(v-model='activateLegalTex',@change='')
        ods-accordion-item(name='1')
            template(slot='title')
              span {{ $t('taxes.filters.legal_text.value') }}
              span.info(v-show='!legalText.length') {{ $t('taxes.no_legalTex') }}
            //- Tabla texto legal
            ods-table(
              v-if='legalText.length > 0 ',
              :data='legalText',
              :default-sort="{ prop: 'category', order: 'ascending' }",
              style='width: 100%',
              @cell-mouse-enter='handleLegalTextCellMouseEnter',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='legalText',
                :label='$t("taxes.filters.legal_text.value")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='taxableEvent',
                :label='$t("taxes.filters.taxable_event.value")',
                :formatter='formatterTaxableEvent',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='global',
                :label='$t("msg_generics.global")',
                sortable='')
                template(slot-scope='scope')
                  ods-switch(
                    v-model='scope.row.global',
                    :active-color='primaryColor',
                    inactive-color='#D5DCE0',
                    @change='updateGlobalFlag(scope.row)')
              ods-table-column(
                label=''
                width='80')
                template(slot-scope='scope')
                  ods-button(
                    v-if='canAdminTaxes',
                    style=' padding-left: 0px; padding-right: 0px; text-align: center;'
                    type='neutral',
                    @click='removeLegalText(scope.$index)')
                    ods-icon(name='close', size='16')
            ods-tooltip(:content='$t("taxes.add_legalText_tooltip")', placement='bottom')
              ods-button.button-collapse-withmargin(
                v-if='canAdminTaxes',
                icon='ods-icon-plus',
                size='small',
                circle,
                @click.native='openDialogAddLegalText()')
                | {{ $t('buttons.btnAdd') }}
    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='large'
            @click='saveTax("taxDetailEditForm")')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
          ods-button(
            ref='buttonCancel',
            type='neutral',
            size='large'
            @click='canceltaxDetailEditForm')
            | {{ $t('buttons.btnClear') }}
    //- Dialogo texto legal
    ods-dialog(
      ref='DialogLegalText'
      :title='$t("taxes.filters.legal_text.value")',
      :visible.sync='isShowDialogLegalText',
      @close='handleCloseDialogLegalText',
      width='30%')
      ods-form(
        ref='formDialogLegalText',
        :model='formDialogLegalText',
        :rules='rulesFormDialogLegalText')
          ods-form-item(
            :label='$t("new_invoice.new_line_invoice.dialog_add_tax.form_add.type_exemption")',
            prop='taxableEvent')
            ods-select(
              v-model='formDialogLegalText.taxableEvent')
              ods-option(
                v-for='typeex in optionsTaxableEvent',
                :key='typeex.id',
                :label='getTaxableEvent(typeex.event)',
                :value='typeex.event')
          ods-form-item(
            prop='legalText',
            :label='$t("taxes.filters.legal_text.value")')
            ods-input(
              :placeholder='$t("taxes.filters.legal_text.placeholder")',
              type='textarea',
              :rows='2',
              v-model='formDialogLegalText.legalText')
          ods-form-item(prop='global')
            ods-checkbox(v-model='formDialogLegalText.global')
              span {{ $t('msg_generics.global') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddLegalText("formDialogLegalText")')
          | {{ $t('buttons.btnAdd') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'
import router from '@/router/index'

export default {
  name: 'b2b-page-tax',
  mixins: [Utils],
  data () {
    return {
      tableTaxSort: {
        prop: 'id',
        order: 'descending'
      },
      activateLegalTex: ['1'],
      isNuevo: false,
      multipleSelectionIds: [],
      showDeleteSelection: false,
      optionsDelete: [
        { value: true, label: this.$t('msg_generics.question.yes') }, { value: false, label: this.$t('msg_generics.question.no') }],
      // INFO
      taxId: null,
      isSuperAdmin: null,
      taxDetailEditForm: {
        // EDITABLES
        project: null,
        taxType: null,
        taxRate: null,
        country: null,
        dateFrom: null,
        dateTo: null,
        enable: true
      },
      modifiedOptionsFilterService: [],
      isShowDialogLegalText: false,
      formDialogLegalText: {
        legalText: null,
        taxableEvent: null,
        global: false
      },
      legalText: [],
      optionsTaxableEvent: [],
      currentRowLegalText: []
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      'optionsFilterInvoiceTaxType',
      'activeUser',
      'countries',
      'canAdminTaxes',
      'optionsFilterService',
      'primaryColor'
    ]),
    rulesTaxDetailEditForm () {
      const _this = this
      const decimalFormatValidator = (rule, value, callback) => {
        if (!this.checkCorrectNumber(value, false)) {
          if (this.getCharFailedNumeric(value) === 'NoNumeric') {
            callback(new Error(this.$t('msg_generics.format_invalid')))
          } else {
            callback(new Error(this.$t('msg_generics.format_invalid') + '. ' + this.$t('msg_generics.character_invalid') + this.getCharFailedNumeric(value)))
          }
        } else if (this.countDecimals(value) > 6) {
          callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
        }
        callback()
      }
      const checkDateFromTo = (rule, value, callback) => {
        const dateFrom = _this.taxDetailEditForm.dateFrom
        const dateTo = _this.taxDetailEditForm.dateTo
        if (dateFrom && dateTo && dateFrom > dateTo) {
          callback(new Error(this.$t('taxes.rules_form.validity_date_msg')))
        }
        callback()
      }
      return {
        taxType: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        taxRate: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { validator: decimalFormatValidator, trigger: 'change' }
        ],
        country: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        dateFrom: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { validator: checkDateFromTo, trigger: 'change' }
        ],
        dateTo: [
          { validator: checkDateFromTo, trigger: 'change' }
        ]
      }
    },
    rulesFormDialogLegalText () {
      return {
        taxableEvent: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'getTaxDetail',
      'modifyTax',
      'deleteTax',
      'getOptionsFilterInvoiceTaxType',
      'getOptionInvoiceLineTaxableEvent',
      'updateGlobalLegalText',
      'getOptionsService'
    ]),

    /** Guarda los cambios del impuesto */
    saveTax (formName) {
      const self = this
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = self.$loading({
            lock: true
          })
          try {
            const request = {
              project: self.taxDetailEditForm.project,
              taxId: this.taxId,
              taxType: self.taxDetailEditForm.taxType,
              taxRate: self.taxDetailEditForm.taxRate,
              country: self.taxDetailEditForm.country,
              legalText: self.legalText,
              dateFrom: self.taxDetailEditForm.dateFrom,
              dateTo: self.taxDetailEditForm.dateTo,
              enable: self.taxDetailEditForm.enable
            }
            console.log('request: ', request)
            const response = await self.modifyTax(request)
            self.taxDetailEditForm = response.data
            this.taxId = self.taxDetailEditForm.id

            router.push({ name: 'taxes-page' })
            let resultMsg = this.$t('taxes.notify.save_changes')
            if (this.isNuevo) {
              resultMsg = this.$t('taxes.notify.add_tax')
            }
            self.$notify({
              title: resultMsg,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            self.getNotificationErrorMessage(error)
          } finally {
            this.isNuevo = false
            load.close()
            self.getTaxOnDatabase()
          }
        } else {
          console.log(
            'submittaxDetailEditForm: ',
            self.taxDetailEditForm
          )
        }
      })
    },
    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.showDeleteSelection = false
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
      if (this.multipleSelectionIds && this.multipleSelectionIds.length > 0) {
        this.showDeleteSelection = true
      }
    },
    handleCloseDialogLegalText () {
      this.$refs.formDialogLegalText.resetFields()
    },
    async openDialogAddLegalText () {
      this.isShowDialogLegalText = true
      if (!this.optionsTaxableEvent.length) {
        this.optionsTaxableEvent = await this.getOptionInvoiceLineTaxableEvent()
      }
    },

    getTaxableEvent (idType) {
      if (idType === null) {
        return ''
      } else {
        return this.$t('new_invoice.new_line_invoice.taxes_table.type_exemption.' + idType)
      }
    },

    formatterTaxableEvent (row, column) {
      if (row.taxableEvent === null) {
        return ''
      } else {
        return this.$t('new_invoice.new_line_invoice.taxes_table.type_exemption.' + row.taxableEvent)
      }
    },

    /* Eliminar el impuesto si no está asignado a ninguna factura */
    async handleRemoveTax (tax) {
      this.$confirm(this.$t('taxes.confirm.delete_tax'), {
        confirmButtonText: this.$t('buttons.btnDelete'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('taxes.load.delete_tax')
        })
        try {
          await this.deleteTax({ taxId: this.taxId })
          this.$notify({
            title: this.$t('taxes.notify.delete_tax'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })

          router.push({ name: 'taxes-page' })
        } catch (error) {
          console.log('handleRemoveTax CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },
    onSubmitAddLegalText (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.legalText.push({ legalText: this.formDialogLegalText.legalText, taxableEvent: this.formDialogLegalText.taxableEvent, global: this.formDialogLegalText.global })
          this.isShowDialogLegalText = false
          console.log('this.formDialogLegalText.global: ', this.formDialogLegalText.global)
        } else {
          console.log('legalText duplicado: ', this.formDialogLegalText.legalText)
        }
      })
    },
    async updateGlobalFlag (row) {
      console.log('row: ', row)
      const request = {
        legalTextId: row.id,
        global: row.global
      }
      await this.updateGlobalLegalText(request)

      this.$notify({
        title: this.$t('taxes.notify.save_changes'),
        type: 'success',
        position: 'top-right',
        customClass: 'b2b-notification-success',
        duration: 10000
      })
    },
    removeLegalText (index) {
      this.legalText.splice(index, 1)
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          if (error.data.message) { errorSms = error.data.message } else { errorSms = error.message }
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },
    async canceltaxDetailEditForm () {
      const load = this.$loading({
        lock: true
      })
      try {
        // Quitamos el foco del boton
        this.$refs.buttonCancel.$el.blur()
        await this.getTaxOnDatabase()
      } catch (error) {
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    },

    async getTaxOnDatabase () {
      try {
        if (this.taxId) {
          console.log('Obtenemos el detalle del impuesto')
          const response = await this.getTaxDetail(this.taxId)
          this.taxDetailEditForm = response
          this.taxDetailEditForm.country = response.countryId
          this.taxDetailEditForm.taxType = response.idTaxType
          this.taxDetailEditForm.taxRate = this.$n(response.taxRate, 'decimal')
          this.legalText = response.taxLegalTaxes
        } else {
          this.$refs.taxDetailEditForm.resetFields()
        }
      } catch (error) {
        this.showNotificationError(error)
      }
    },
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRowDataconfiguration = row
    },
    handleLegalTextCellMouseEnter (row, column, cell, event) {
      this.currentRowLegalText = row
    }
  },
  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })

    try {
      this.taxId = this.$route.params.taxId
      if (this.$route.params.taxId == 'newtax') { // eslint-disable-line
        this.isNuevo = true
        this.taxId = null
      }
      if (this.optionsFilterService.length > 1 && this.isNuevo) {
        const dataQueryService = { page: 0, size: 1000, sort: 'name,ASC' }
        this.modifiedOptionsFilterService = await this.getOptionsService(dataQueryService)
        this.modifiedOptionsFilterService = [{ id: -2, name: this.$t('msg_generics.all') }, ...this.modifiedOptionsFilterService]
        this.taxDetailEditForm.project = -2
      }
      if (!this.isNuevo) {
        // Get Info
        await this.getTaxOnDatabase()
      }
    } catch (error) {
      console.log('Info: Inicializando datos created')
      this.showNotificationError(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep strong {
  font-weight: bold;
}
::v-deep em {
  font-style: italic;
}
  ::v-deep .wangEditor-container {
    max-height: 235px;
    min-height: 200px;
  }
   ::v-deep .wangEditor-container .wangEditor-txt {
    max-height: 170px;
    min-height: 170px;
  }
  ::v-deep .wangEditor-menu-container .menu-group {
    float: left;
    padding: 0 0px;
  }
  ::v-deep .wangEditor-menu-container .menu-item {
    height: 25px;
    width: 25px;
  }
  ::v-deep .wangEditor-menu-container .menu-item a {
    padding: 6px 0 0 0;
  }
.b2b-page-tax {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
    }
  }
  .form-actions {
    padding-top: 30px;
    padding-bottom: 30px;
    .ods-button {
      float: right;
    }
  }
  #editor {
    height: 375px;
  }

  .ql-showHtml:after {
    content: "[source]";
  }

  .collapse {
    margin-top: 25px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row {
        .ods-button {
          padding: rem(0);
          margin-left: rem(0);
          margin-right: rem(0);
          i {
            margin-left: rem(0);
          }
        }
        .first-button {
          padding: rem(0);
          margin-left: rem(0);
          margin-right: rem(12);
          i {
            margin-left: rem(0);
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    .button-collapse-withmargin {
      float: right;
      margin-top: 2rem;
    }

    ::v-deep .ods-module {
      &__body {
        padding: 0px;
      }
    }
  }
  .ods-tag + .ods-tag {
    margin-left: rem(10);
  }
  .ods-button + .ods-button {
    margin-left: rem(0) !important;
  }
  div.flexClass{
    display: inline-flex;
  }
  .ods-pagination .ods-select--mini {
    padding-right: 10px;
  }
  ::v-deep .ods-date-editor.ods-input {
    width: 109px;
    margin-right: 24px;
  }
  ::v-deep .ods-input--prefix .ods-input__inner{
    padding-left: 10px;
  }

}
</style>
